import { QueryClient } from "@tanstack/react-query";
import { createRouter } from "@tanstack/react-router";
import { routeTree } from "./routeTree.gen";
import { RoutePending } from "./components/RoutePending";

export const getRouter = () => {
  const queryClient = new QueryClient();

  const router = createRouter({
    routeTree,
    context: { queryClient },
    scrollRestoration: true,
    defaultPreloadStaleTime: 0,
    // Hover/touch-start warms the loader, so most desktop clicks land on
    // already-fetched data and skip the pending state entirely.
    defaultPreload: "intent",
    defaultPreloadDelay: 50,
    // Default is 1000ms, which meant a full silent second of stale content on
    // every data page. 150ms is past the "instant" threshold, so quick
    // navigations still swap without a skeleton flash.
    defaultPendingMs: 150,
    defaultPendingMinMs: 300,
    defaultPendingComponent: RoutePending,
  });

  return router;
};
